unit View.Cidade_Provedor;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, UConstantes, System.StrUtils,
  WEBLib.WebCtrls, UHelperServer, App.Types, UUtils;

type
  TfrmCidadeProvedor = class(TForm)
    tblCidades: TDBTableControl;
    edtPesquisaCidade: TEdit;
    cdsCidades: TXDataWebDataSet;
    cdsCidadesNome: TStringField;
    cdsCidadesufSigla: TXDataWebDatasetField;
    dtsCidades: TDataSource;
    tmrConsultaCidade: TTimer;
    div_informacoes_homologacao: THTMLDiv;
    cdsCidadesprovedor_id: TIntegerField;
    cdsCidadesprovedornome: TXDataWebDatasetField;
    cdsCidadesprovedor: TXDataWebEntityField;
    cdsCidadesprovedorhomologado: TXDataWebDatasetField;
    procedure edtPesquisaCidadeKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edtPesquisaCidadeKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaCidadeTimer(Sender: TObject);
    procedure tblCidadesGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblCidadesGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblCidadesClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure WebFormCreate(Sender: TObject);
  private
    procedure RealizarConsulta;
    procedure SetInformacoesHomologacao;
  public
    class procedure Display(AElementId: string; LoginProc: TSuccessProc); overload;
    class procedure Display(AElementId: string; LoginProc: TSuccessProc;
      AMsg: string); overload;
  protected procedure LoadDFMValues; override; end;

var
  frmCidadeProvedor: TfrmCidadeProvedor;

implementation

uses
  ConnectionModule;

{$R *.dfm}

class procedure TfrmCidadeProvedor.Display(AElementId: string;
  LoginProc: TSuccessProc; AMsg: string);

  procedure AfterCreate(AForm: TObject);
  begin
    //
  end;

begin
  if Assigned(frmCidadeProvedor) then
    frmCidadeProvedor.Free;
  frmCidadeProvedor := TfrmCidadeProvedor.CreateNew(AElementId, @AfterCreate);
end;

class procedure TfrmCidadeProvedor.Display(AElementId: string;
  LoginProc: TSuccessProc);
begin
  TfrmCidadeProvedor.Display(AElementId, LoginProc, '');
end;

procedure TfrmCidadeProvedor.edtPesquisaCidadeKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCidade.Enabled := False;

  if tblCidades.Visible then
    tblCidades.Visible := False;

  if div_informacoes_homologacao.Visible  then
    div_informacoes_homologacao.Visible := False;
end;

procedure TfrmCidadeProvedor.edtPesquisaCidadeKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCidade.Interval := FTimerConsulta;
  tmrConsultaCidade.Enabled := True;
end;

procedure TfrmCidadeProvedor.RealizarConsulta;
var
  lFilter : string;
begin
  if Trim(edtPesquisaCidade.Text) <> '' then
  begin
    lFilter := '$filter=contains(Nome, '+QuotedStr(edtPesquisaCidade.Text)+
      ')&$expand=uf,provedor&$orderby=Nome';
  end;

  TUtils.ChamarDivLoading;
  cdsCidades.DisableControls;

  try
    cdsCidades.Close;
    cdsCidades.QueryString := lFilter;
    cdsCidades.Load;
  finally
    cdsCidades.EnableControls;
    TUtils.OcultarDivLoading;
  end;
end;

procedure TfrmCidadeProvedor.SetInformacoesHomologacao;
var
  lHtml : string;
begin

  lHtml := '<p class="text-center mt-0 facil_color_gray facil_font">Resultado</p>';

  if (cdsCidades.FieldByName('provedor_id').AsString = '') then
    lHtml := lHtml + '<p class="text-center facil_conteudo_grande facil_font text-danger facil_spacing">CIDADE NÃO ATENDIDA</p>'
  else if not cdsCidades.FieldByName('provedor.homologado').AsBoolean then
  begin
    lHtml := lHtml + '<p class="text-center facil_conteudo_grande text-danger facil_font facil_spacing">CIDADE NÃO ATENDIDA</p> ' +
      '<p class="text-center facil_spacing facil_color_black facil_font mt-0">Provedor: <b>'+cdsCidades.FieldByName('provedor.nome').AsString+'</b></p>';
  end
  else
  begin
    lHtml := lHtml + '<p class="text-center facil_conteudo_grande text-success facil_font facil_spacing">CIDADE ATENDIDA</p> ' +
      '<p class="text-center facil_spacing facil_color_black facil_font mt-0">Provedor: <b>'+cdsCidades.FieldByName('provedor.nome').AsString+'</b></p>';
  end;

  div_informacoes_homologacao.HTML.Clear;
  div_informacoes_homologacao.HTML.Add(lHtml);
  div_informacoes_homologacao.Visible := True;
end;

procedure TfrmCidadeProvedor.tblCidadesClickCell(Sender: TObject; ACol,
  ARow: Integer);
begin
  tblCidades.DataSource.DataSet.RecNo := ARow;
  edtPesquisaCidade.Text := UpperCase(cdsCidades.FieldByName('Nome').AsString + ' - ' +
     cdsCidades.FieldByName('uf.Sigla').AsString);
  tmrConsultaCidade.Enabled := False;
  tblCidades.Visible := False;
  SetInformacoesHomologacao;
end;

procedure TfrmCidadeProvedor.tblCidadesGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'd-none'
  else
    AClassName := 'facil_font facil_font_size_input';
end;

procedure TfrmCidadeProvedor.tblCidadesGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblCidades.Columns[ACol].DataField, ['Nome']) of
      0:  AValue := UpperCase(AValue + ' - ' + cdsCidades.FieldByName('uf.Sigla').AsString);
    end;
  end;
end;

procedure TfrmCidadeProvedor.tmrConsultaCidadeTimer(Sender: TObject);
begin
  RealizarConsulta;

  tmrConsultaCidade.Enabled := False;
  tmrConsultaCidade.Interval := FTimerConsulta;

  if Trim(edtPesquisaCidade.Text) <> '' then
    tblCidades.Visible := True
  else
  begin
    if tblCidades.Visible then
      tblCidades.Visible := False;
  end;
end;

procedure TfrmCidadeProvedor.WebFormCreate(Sender: TObject);
begin
  if edtPesquisaCidade.CanFocus then
    edtPesquisaCidade.SetFocus;
end;

procedure TfrmCidadeProvedor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  tblCidades := TDBTableControl.Create('tabela_cidades');
  edtPesquisaCidade := TEdit.Create('pesquisa_cidade');
  div_informacoes_homologacao := THTMLDiv.Create('informacoes_homologacao');
  cdsCidades := TXDataWebDataSet.Create(Self);
  cdsCidadesNome := TStringField.Create(Self);
  cdsCidadesufSigla := TXDataWebDatasetField.Create(Self);
  cdsCidadesprovedor_id := TIntegerField.Create(Self);
  cdsCidadesprovedornome := TXDataWebDatasetField.Create(Self);
  cdsCidadesprovedor := TXDataWebEntityField.Create(Self);
  cdsCidadesprovedorhomologado := TXDataWebDatasetField.Create(Self);
  dtsCidades := TDataSource.Create(Self);
  tmrConsultaCidade := TTimer.Create(Self);

  tblCidades.BeforeLoadDFMValues;
  edtPesquisaCidade.BeforeLoadDFMValues;
  div_informacoes_homologacao.BeforeLoadDFMValues;
  cdsCidades.BeforeLoadDFMValues;
  cdsCidadesNome.BeforeLoadDFMValues;
  cdsCidadesufSigla.BeforeLoadDFMValues;
  cdsCidadesprovedor_id.BeforeLoadDFMValues;
  cdsCidadesprovedornome.BeforeLoadDFMValues;
  cdsCidadesprovedor.BeforeLoadDFMValues;
  cdsCidadesprovedorhomologado.BeforeLoadDFMValues;
  dtsCidades.BeforeLoadDFMValues;
  tmrConsultaCidade.BeforeLoadDFMValues;
  try
    Name := 'frmCidadeProvedor';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    tblCidades.SetParentComponent(Self);
    tblCidades.Name := 'tblCidades';
    tblCidades.Left := 20;
    tblCidades.Top := 36;
    tblCidades.Width := 300;
    tblCidades.Height := 200;
    tblCidades.BorderColor := clSilver;
    tblCidades.ChildOrder := 6;
    tblCidades.ElementTableClassName := 'table table-striped table-bordered table-hover';
    tblCidades.Visible := False;
    SetEvent(tblCidades, Self, 'OnClickCell', 'tblCidadesClickCell');
    SetEvent(tblCidades, Self, 'OnGetCellData', 'tblCidadesGetCellData');
    SetEvent(tblCidades, Self, 'OnGetCellClass', 'tblCidadesGetCellClass');
    tblCidades.Columns.Clear;
    with tblCidades.Columns.Add do
    begin
      DataField := 'Nome';
      Title := 'Nome';
    end;
    tblCidades.DataSource := dtsCidades;
    edtPesquisaCidade.SetParentComponent(Self);
    edtPesquisaCidade.Name := 'edtPesquisaCidade';
    edtPesquisaCidade.Left := 20;
    edtPesquisaCidade.Top := 8;
    edtPesquisaCidade.Width := 300;
    edtPesquisaCidade.Height := 22;
    edtPesquisaCidade.ChildOrder := 7;
    edtPesquisaCidade.HeightPercent := 100.000000000000000000;
    edtPesquisaCidade.WidthPercent := 100.000000000000000000;
    SetEvent(edtPesquisaCidade, Self, 'OnKeyDown', 'edtPesquisaCidadeKeyDown');
    SetEvent(edtPesquisaCidade, Self, 'OnKeyUp', 'edtPesquisaCidadeKeyUp');
    div_informacoes_homologacao.SetParentComponent(Self);
    div_informacoes_homologacao.Name := 'div_informacoes_homologacao';
    div_informacoes_homologacao.Left := 344;
    div_informacoes_homologacao.Top := 36;
    div_informacoes_homologacao.Width := 100;
    div_informacoes_homologacao.Height := 41;
    div_informacoes_homologacao.ChildOrder := 2;
    div_informacoes_homologacao.Role := '';
    div_informacoes_homologacao.Visible := False;
    cdsCidades.SetParentComponent(Self);
    cdsCidades.Name := 'cdsCidades';
    cdsCidades.EntitySetName := 'Cidades_Provedor';
    cdsCidades.Connection := DMConnection.CidadesProvedorConnection;
    cdsCidades.QueryTop := 5;
    cdsCidades.Left := 24;
    cdsCidades.Top := 264;
    cdsCidadesNome.SetParentComponent(cdsCidades);
    cdsCidadesNome.Name := 'cdsCidadesNome';
    cdsCidadesNome.FieldName := 'Nome';
    cdsCidadesNome.Required := True;
    cdsCidadesNome.Size := 255;
    cdsCidadesufSigla.SetParentComponent(cdsCidades);
    cdsCidadesufSigla.Name := 'cdsCidadesufSigla';
    cdsCidadesufSigla.FieldKind := fkCalculated;
    cdsCidadesufSigla.FieldName := 'uf.Sigla';
    cdsCidadesufSigla.Calculated := True;
    cdsCidadesprovedor_id.SetParentComponent(cdsCidades);
    cdsCidadesprovedor_id.Name := 'cdsCidadesprovedor_id';
    cdsCidadesprovedor_id.FieldName := 'provedor_id';
    cdsCidadesprovedornome.SetParentComponent(cdsCidades);
    cdsCidadesprovedornome.Name := 'cdsCidadesprovedornome';
    cdsCidadesprovedornome.FieldKind := fkCalculated;
    cdsCidadesprovedornome.FieldName := 'provedor.nome';
    cdsCidadesprovedornome.Calculated := True;
    cdsCidadesprovedor.SetParentComponent(cdsCidades);
    cdsCidadesprovedor.Name := 'cdsCidadesprovedor';
    cdsCidadesprovedor.FieldName := 'provedor';
    cdsCidadesprovedorhomologado.SetParentComponent(cdsCidades);
    cdsCidadesprovedorhomologado.Name := 'cdsCidadesprovedorhomologado';
    cdsCidadesprovedorhomologado.FieldKind := fkCalculated;
    cdsCidadesprovedorhomologado.FieldName := 'provedor.homologado';
    cdsCidadesprovedorhomologado.Calculated := True;
    dtsCidades.SetParentComponent(Self);
    dtsCidades.Name := 'dtsCidades';
    dtsCidades.DataSet := cdsCidades;
    dtsCidades.Left := 96;
    dtsCidades.Top := 264;
    tmrConsultaCidade.SetParentComponent(Self);
    tmrConsultaCidade.Name := 'tmrConsultaCidade';
    tmrConsultaCidade.Enabled := False;
    SetEvent(tmrConsultaCidade, Self, 'OnTimer', 'tmrConsultaCidadeTimer');
    tmrConsultaCidade.Left := 192;
    tmrConsultaCidade.Top := 264;
  finally
    tblCidades.AfterLoadDFMValues;
    edtPesquisaCidade.AfterLoadDFMValues;
    div_informacoes_homologacao.AfterLoadDFMValues;
    cdsCidades.AfterLoadDFMValues;
    cdsCidadesNome.AfterLoadDFMValues;
    cdsCidadesufSigla.AfterLoadDFMValues;
    cdsCidadesprovedor_id.AfterLoadDFMValues;
    cdsCidadesprovedornome.AfterLoadDFMValues;
    cdsCidadesprovedor.AfterLoadDFMValues;
    cdsCidadesprovedorhomologado.AfterLoadDFMValues;
    dtsCidades.AfterLoadDFMValues;
    tmrConsultaCidade.AfterLoadDFMValues;
  end;
end;

end.
